// extracted by mini-css-extract-plugin
module.exports = {"container":"_11XVd","innerContainer":"UcpR7","title":"_27D85","body":"_3-Ynj","list":"_38QIY","button":"ttqr8","isMuted":"_16MjU"};